import { all, call, put, select, takeEvery } from "redux-saga/effects"
import { DckActionTypes, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../items/types"
import moment from "moment"
import { getDefaultPagedResult, HTTP_VERB } from "../../../lib/utils"
import { makeSagaQuery } from "../utils"
import apiServerConstants from "../apiServerConstants"
import ProcessTypes from "../../processes/types"

const manageCustomerItem = item => {

  const { createdOn, business } = item
  item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
  item.affiliated = business ? `${business.name} - ${business.businessId}` : ''

  return item
}

function* loadCustomersSaga({ filteringOptions }) {

  yield makeSagaQuery(
    `${apiServerConstants.host}/customers/filter`, 
    HTTP_VERB.POST,
    JSON.stringify(filteringOptions),
    ProcessTypes.LAOD_CUSTOMER_PROCESS,
    true,
    response => {

      const data = response.body
      data.content = data.content.map(manageCustomerItem)

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Customer,
        data
      }
    }
  )
}

function *reloadCustomer({ id }) {

  const response = yield makeSagaQuery(
    `${apiServerConstants.host}/customers/${id}`, 
    HTTP_VERB.GET,
    null,
    ProcessTypes.RELOAD_CUSTOMER_PROCESS,
    true
  )

  if (response) {
    yield call(setCustomer, { id, data: response.body })
  }
}

function *setCustomer({ id, data }) {

  const originalPagedCustomers = yield select(state => DckSelectors.selectAllItems(state, ItemTypes.Customer)),

  pagedCustomers = originalPagedCustomers instanceof Array ? getDefaultPagedResult() : originalPagedCustomers,
  index = pagedCustomers.content.findIndex(elt => elt.id === id),
  fullData = manageCustomerItem(data)

  if (index > -1) {
    pagedCustomers.content[index] = fullData
  }
  else {
    pagedCustomers.content.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Customer,
    data: pagedCustomers
  })
}

function* customersSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Customer,
      loadCustomersSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.Customer,
      setCustomer
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_RELOAD &&
        action.itemType === ItemTypes.Customer,
      reloadCustomer
    ),
  ])
}

export default customersSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/customers.js